import { useState } from 'react';
import { parseChatbotWidgetData } from '@/modules/gpt-chats/components/agents-configuration/components/preview-section/preview-chatbot/utils';
import { useGetAgentById } from '@/modules/gpt-chats/hooks/use-agents';

import { PreviewChatbot } from './preview-chatbot';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui-kit/sheet';
import { useChatStore } from '@/modules/gpt-chats/hooks/use-chat-store';

type AgentsConfigPreviewSectionProps = {
  agentId: string;
  isMobile: boolean;
  showMobilePreview: boolean;
  onCloseMobilePreview: () => void;
};

export const AgentsConfigPreviewSection = ({
  agentId,
  isMobile,
  showMobilePreview,
  onCloseMobilePreview,
}: AgentsConfigPreviewSectionProps) => {
  const { data } = useGetAgentById(agentId);

  const widget = data?.agent?.widget ? parseChatbotWidgetData(data.agent.widget) : null;

  const { deleteChat } = useChatStore();
  const [chatbotKey, setChatbotKey] = useState<number>(0);

  const resetChat = () => {
    if (data?.agent.widget_id) {
      deleteChat(data.agent.widget_id);
    }
    setChatbotKey((prev) => prev + 1);
  };

  const previewContent =
    widget && data?.agent ? (
      <PreviewChatbot
        key={`${data?.agent.id}-${chatbotKey}`}
        widget={widget}
        widgetId={data.agent.widget_id}
        agentName={data.agent?.name}
        agentId={agentId}
        humanLogoUrl=""
        onResetChat={resetChat}
        onClosePreview={isMobile ? onCloseMobilePreview : undefined}
        lastUpdatedDate={data.agent.last_updated_date}
      />
    ) : (
      <div className="flex h-full items-center justify-center text-medium-emphasis">
        No preview available
      </div>
    );

  if (isMobile) {
    return (
      <Sheet open={showMobilePreview} onOpenChange={onCloseMobilePreview}>
        <SheetContent
          side="bottom"
          className="h-full rounded-t-[24px] border-t-0 p-0 shadow-2xl"
          onInteractOutside={(e) => e.preventDefault()}
        >
          <div className="h-full">{previewContent}</div>
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <>
      {/* fake div to adjust the design requirement */}
      <div className="invisible w-[500px] flex-shrink-0 grow-0"> </div>

      <Sheet open={true} modal={false}>
        <SheetContent
          // hideClose
          side="right"
          className="fixed right-0 top-[59px] h-[calc(100vh-60px)] !w-[500px] !max-w-[500px] flex-shrink-0 border-l bg-background p-0"
          onInteractOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          <SheetHeader className="sr-only">
            <SheetTitle>Preview</SheetTitle>
          </SheetHeader>
          {previewContent}
        </SheetContent>
      </Sheet>
    </>
  );
};
